<template>
	<b-modal class="modal-content" ref="mdlGestioneAttivitaClientiListSelectModal" size="xl" :title="title" scrollable no-close-on-backdrop no-close-on-select ok-title="Associa" @shown="onShownMdlGestioneAttivitaClientiListSelectModal" @ok="oOkMdlGestioneAttivitaClientiListSelectModal">
		<gestione-attivita-clienti-list-component :selectable="true" ref="cmpGestioneAttivitaClientiListComponent"></gestione-attivita-clienti-list-component>
	</b-modal>
</template>

<script>
import GestioneAttivitaClientiListComponent from "./GestioneAttivitaClientiListComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin],
	components: { GestioneAttivitaClientiListComponent },
	data() {
		return {
			title: "Modal",
			tipo: null,
			idAsset: null,
			pathResource: "/gestioneattivitaclientiasset",
			numeroRecords: 0,
			numeroRecordsSalvati: 0,
			allSavedSuccess: true,
		};
	},
	methods: {
		show(title, idAsset) {
			let me = this;
			me.title = title;
			me.idAsset = idAsset;
			me.$refs.mdlGestioneAttivitaClientiListSelectModal.show();
		},
		onShownMdlGestioneAttivitaClientiListSelectModal() {
			let me = this;
			me.$refs.cmpGestioneAttivitaClientiListComponent.init({ tipo: me.tipo });
		},
		oOkMdlGestioneAttivitaClientiListSelectModal(bvModalEvent) {
			let me = this;
			bvModalEvent.preventDefault();
			let selectionRows = this.$refs.cmpGestioneAttivitaClientiListComponent.getSelectionRows();
			console.log(selectionRows);
			me.numeroRecords = selectionRows.length;
			selectionRows.forEach((element) => {
				me.associaAsset(element.id);
			});
		},
		associaAsset(idCliente) {
			let me = this;
			let body = { idCliente: idCliente, idAsset: me.idAsset };
			me.saveResource(me.pathResource, body, me.associaAssetSuccess, me.associaAssetError);
		},
		associaAssetSuccess() {
			let me = this;
			this.numeroRecordsSalvati++;
			me.$bvToast.toast("Associazione avvenuta con succedsso ", {
				title: "Elemento Associato",
				variant: "success",
				solid: true,
			});
			me.$emit("associzioneAvvenuta");
			me.closeModal();
		},
		associaAssetError(error) {
			let me = this;
			this.numeroRecordsSalvati++;
			me.allSavedSuccess = false;
			me.$bvToast.toast("Errore nel salvataggio" + error.message, {
				title: "Errore",
				variant: "danger",
				solid: true,
			});
			me.closeModal();
		},
		closeModal() {
			if (this.numeroRecordsSalvati === this.numeroRecords && this.allSavedSuccess) {
				this.$refs.mdlGestioneAttivitaClientiListSelectModal.hide();
			}
		},
	},
};
</script>

<style></style>
